define(["require", "exports"], function (require, exports) {
    exports.closeModal = function () {
        document.querySelector(".close").click();
    };
    exports.showLoading = function () {
        $("#loading2").show();
    };
    exports.hideLoading = function () {
        $("#loading2").hide();
    };
});
//tsconfig ten allowJs:true
//# sourceMappingURL=sitesource.js.map